
import "./Home.css";
import Navbar from "./navbar";

function About() {

    return (
        <div className="entirePageContainerAbout">
            <Navbar />
            <div className="contentContainerAbout">
                <div className="aboutText">
                    
                    <p id="aboutPassage">
                    <h2 id="aboutHeader">about</h2>
                    Jackson Smith (b.2004) is a photographer based in Nashville, TN. He started studying photography 
                    at Volunteer State Community College where he found his passion for photography and went on to pursue his studies elsewhere at Middle Tennessee State University.
                    
                    </p>
                    <p id="aboutPassage">
                      -With my hand on the camera I always strive to achieve a strange and beautiful feeling with my work. I heavily lean into surrealist influences and make it a point to make mistakes to learn. I believe in carefully allowed mistakes to still give a real feeling to the work and add another layer of beauty, similar to the japanese philosphy of Wabi-sabi. 
                      I enjoy impermanence and flaw, as for everything in life is perfectly imperfect. I strive to learn and master all processes and formats I can within photography so I can use any tool I can to take the images out of my mind and into the world. I am not afraid to learn new things and use formats as such as film in every way I can.-
                    </p>
                    <p id="aboutPassage">
                        "Digital photography is a science and film photography is a chemical miracle..." -Steven Spielberg
                    </p>
                </div>
                <div className="aboutImage">
                    <img className="aboutPic" src={`${process.env.PUBLIC_URL}/otherPhotos/aboutSlideshowPics/photoOne.JPG`} alt="jacksonOne" />
                </div>
            </div>
        </div>
    );
}

export default About;
